var _path, _path2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    clipRule: "evenodd",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "evenodd",
    d: "M38,42H10c-2.209,0-4-1.791-4-4V10c0-2.209,1.791-4,4-4h28 c2.209,0,4,1.791,4,4v28C42,40.209,40.209,42,38,42z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.257,34h-6.437L13.829,14h6.437L34.257,34z M28.587,32.304h2.563L19.499,15.696h-2.563 L28.587,32.304z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "15.866,34 23.069,25.656 22.127,24.407 13.823,34"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.45,21.721 25.355,23.01 33.136,14 31.136,14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.4d28e8fd118b299940c460c78dd73b27.svg";
export { ForwardRef as ReactComponent };